import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import billingAutomation from './billingAutomation/billingAutomation.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import lumerai from './lumerai/lumerai.routes';
import keepalive from './keepalive/keepalive.routes';
import ticketsSettings from './tickets/tickets.routes';
import locations from './locations/locations.routes';
import staffStickers from './staffStickers/staffStickers.routes';
import ModulePaywall from './components/ModulePaywall.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...billingAutomation.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...lumerai.routes,
    ...keepalive.routes,
    {
      path: frontendURL('accounts/:accountId/settings/calendar'),
      name: 'calendar_settings',
      meta: { permissions: ['administrator', 'calendar_manage'] },
      component: () => import('../calendar/CalendarIndex.vue'),
    },
    ...ticketsSettings.routes,
    ...locations.routes,
    ...staffStickers.routes,
    {
      path: frontendURL('accounts/:accountId/settings/module-paywall'),
      name: 'module_paywall',
      component: ModulePaywall,
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
    },
  ],
};
